import { render, staticRenderFns } from "./SurveyFoodList.vue?vue&type=template&id=eb55ddea&lang=pug&"
import script from "./SurveyFoodList.vue?vue&type=script&lang=js&"
export * from "./SurveyFoodList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyFoodList.vue?vue&type=style&index=0&id=eb55ddea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports